import keyMirror from 'keymirror';
import i18n from 'i18next';

export const parentRequestModalActionTypes = keyMirror({
	TOGGLE_PARENT_REQUEST_MODAL: null,
	HANDLE_PARENT_REQUEST_MODAL: null,
	SET_PACKAGE_NAME: null,

	GET_AVAILABLE_PACKAGES_REQUEST: null,
	GET_AVAILABLE_PACKAGES_SUCCESS: null,
	GET_AVAILABLE_PACKAGES_ERROR: null,

	PARENT_PAYMENT_REQUEST: null,
	PARENT_PAYMENT_SUCCESS: null,
	PARENT_PAYMENT_ERROR: null,

	WHATSAPP_SHARE_REQUEST: null,
	WHATSAPP_SHARE_ERROR: null,
});

export const tabs = () => [
	{
		title: i18n.t('modals.parent_request.tabs.whatsapp'),
		value: 'active',
		index: 0,
	},
	{
		title: i18n.t('modals.parent_request.tabs.email'),
		value: 'invited',
		index: 1,
	},
];
